
import { Options, Vue } from "vue-class-component";
import HelloWorld from "@/components/HelloWorld.vue";
import DefaultLayout from "@/layout/DefaultLayout.vue";

@Options({
  components: {
    DefaultLayout,
    HelloWorld,
  },
})
export default class Home extends Vue {
  private goToUsers(): void {
    this.$router.push({ name: "UserList" });
  }
  private goToPages(): void {
    this.$router.push({ name: "PageList" });
  }
}
